module.exports = __webpack_public_path__ + "static/img/talent-june.5572108.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/genestesting/talent-june.png
// module id = Ev31
// module chunks = 0